const PairingFormValidation = {
    onBranchDateTimeChange: (bankStatementDateValue, moreThanWeekErrorMessage, futureValueErrorMessage) => {
        const dateInput = $('.branch-date-time');

        const date = window.moment(dateInput.val());
        const payment = window.moment(bankStatementDateValue);

        const diff = window.moment.duration(payment.diff(date));
        if (diff.asDays() > 7) {
            if (!confirm(moreThanWeekErrorMessage)) {
                dateInput.val(null);
            }
        }
        if (diff.asDays() < 0) {
            if (!confirm(futureValueErrorMessage)) {
                dateInput.val(null);
            }
        }
    }
}

window.pairingFormValidation = PairingFormValidation;
